import "./PageList.scss"

import { Link } from "react-router-dom"

import loadPages from "../utils/loadPages"

function PageList() {
  const pages = loadPages()

  return (
    <div>
      <nav>
        <ul>
          {Object.keys(pages).map((page) => (
            <li key={page}>
              <Link to={page === "Home" ? "/" : `/${page.toLowerCase()}`}>{page}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default PageList
